import { render } from "./Languages.vue?vue&type=template&id=44f8f53e"
import script from "./Languages.vue?vue&type=script&lang=js"
export * from "./Languages.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/ThesauRex/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__